import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { Building } from './building';
import { BuildingPropertyTaxAssessment } from './building-property-tax-assesment';

export class PropertyTax extends ModelBase {
  constructor(dataContext?: any) {
    super();
  }
  id: string;
  propertyId: string;
  assessmentUnitTypeCode: number;
  assessmentYear: number;
  decisionDate: LocalDate;
  buildingPropertyTaxAssessments: BuildingPropertyTaxAssessment[];
  typeCodeBuildingSum: Money;
  typeCodeLandSum: Money;
  typeCodeTotalSum: Money;
}
